import { Avatar, Box, Chip, Stack, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { useApiQuery } from '../query/hooks';
import { graphql } from '../gql';
import { FormattedMessage } from 'react-intl';

const listMembersQuery = graphql(`
	query membersSelect_listMember {
		listMember {
			id
			name
			avatar {
				url(width: 40, height: 40)
			}
		}
	}
`);

type OwnersCheckListProps = Readonly<{
	value: readonly string[];
	onChange(newTags: readonly string[]): void;
	loading?: boolean;
	size: 'medium' | 'small';
}>;

export const OwnersCheckList: FC<OwnersCheckListProps> = ({ value, onChange, loading, size }) => {
	const { data } = useApiQuery(listMembersQuery);
	const theme = useTheme();

	const owners = data?.listMember.map((member) => member) ?? [];

	const selectedOwners = value.filter((id) => owners.some((o) => o.id === id));

	if (loading) {
		return (
			<Typography sx={{ color: theme.palette.secondary.main }}>
				<FormattedMessage id={'common.loading'} />
			</Typography>
		);
	}

	return (
		<Stack direction={'column'} gap={2}>
			{owners.length > 0 && (
				<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
					{owners.map((owner) => (
						<Chip
							key={owner.id}
							label={owner.name}
							variant={'outlined'}
							size={size}
							avatar={<Avatar alt={owner.name} src={owner.avatar?.url ?? undefined} />}
							sx={{
								backgroundColor: theme.palette.secondary.lighter,
								borderColor: selectedOwners.includes(owner.id) ? theme.palette.primary[400] : theme.palette.secondary[400],
								opacity: selectedOwners.includes(owner.id) ? 1 : 0.5,
							}}
							onClick={() =>
								selectedOwners.includes(owner.id)
									? onChange(selectedOwners.filter((pId) => pId !== owner.id))
									: onChange(selectedOwners.concat(owner.id))
							}
						/>
					))}
				</Box>
			)}
		</Stack>
	);
};
